import styled from 'styled-components';

import { theme } from '_constants/theme';

const { colors, spaces } = theme;

const StyledDivider = styled.div`
  height: 1px;
  margin-bottom: ${spaces.regular}px;
  background: ${colors.gray[200]};
`;

const Divider = () => <StyledDivider />;

export default Divider;
